module ConditionalFormControls {
  export function construct() {
    $("[data-toggle='formcontrols']").change(function () {
      const element = $(this);
      const value = element.val();
      const triggerValue = element.attr("data-triggervalue");
      const formControls = $(element.attr("data-target"));
      formControls.collapse(value === triggerValue ? "show" : "hide");
    });
    $("[data-toggle='formcontrols']").change();
  }
}